import { DateTime } from 'luxon';

export default function isSleeping(user) {
  return (
    DateTime.now().diff(DateTime.fromISO(user.data.sleepingStartingAt)).milliseconds > 0 &&
    DateTime.now().diff(DateTime.fromISO(user.data.sleepingEndingAt)).milliseconds < 0
  );
}
